export default "__VITE_ASSET__BYxU0Uq___"